export enum LayingType {
  horizontal = 'horizontal',
  diagonal = 'diagonal',
}

export const LayingTypeLabel = {
  [LayingType.horizontal]: 'Горизонтальное',
  [LayingType.diagonal]: 'Диагональное',
};

export const LayingTypeCalculationPercentage = {
  [LayingType.horizontal]: '5%',
  [LayingType.diagonal]: '15%',
};
